import * as React from "react";
import FormInput from "./FormInput";
import InputProps from "../../../model/form/InputProps";
import { buildClasses } from "../../../utils/classes";
import InputState from "../../../model/form/InputState";

export default class UrlInput extends React.PureComponent<InputProps> {
  constructor(props: InputProps) {
    super(props);
    this.template = this.template.bind(this);
    this.urlValidator = this.urlValidator.bind(this);
    this.urlValidator["errorMessage"] = i18n["Form.Error.InvalidUrl"];
    this.urlValidator["messageLevel"] = this.props.messageLevel;
  }

  template(state: InputState, input) {
    return (
      <div
        className={buildClasses(
          {
            invalid: () => state.status.invalid && !state.status.pristine,
            none: () => state.status.hidden,
          },
          "input-group grow"
        )}
      >
        <div className="group">
          <input
            type="url"
            name={this.props.name}
            id={this.props.name}
            placeholder={this.props.placeholder}
            onChange={input.change}
            onBlur={() => {
              const processedValue = this.postProcessValue(state.value);
              state.setValue(processedValue);
              input.dirty();
            }}
            value={state.value}
            readOnly={this.props.readOnly}
          />
          {!state.status.invalid && !state.status.pristine && (
            <div className="h-flex centered valid">
              <i className="ic_check" />
            </div>
          )}
        </div>
        <div className="error-message">{state.status.errorMessage}</div>
      </div>
    );
  }

  private postProcessValue(url: string) {
    if (this.isValidUrl(url) && url != "") {
      return new URL(this.prependProtocolIfMissing(url)).href;
    } else {
      return url;
    }
  }

  private prependProtocolIfMissing(url: string) {
    if (url != "") {
      return url.match(/[a-z]+:\/\//i) ? url : "https://" + url;
    } else {
      return url;
    }
  }

  private isValidUrl(value: string) {
    try {
      if (value != "") {
        new URL(this.prependProtocolIfMissing(value));
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  private urlValidator(value): boolean {
    return !this.isValidUrl(value);
  }

  render() {
    return (
      <FormInput
        {...this.props}
        validators={[...(this.props.validators ?? []), this.urlValidator]}
        template={this.template}
      />
    );
  }
}
